import React from 'react';
import PropTypes from 'prop-types';

const Pause02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="3" width="4" height="14" rx="1" fill={color} />
    <rect x="12" y="3" width="4" height="14" rx="1" fill={color} />
  </svg>
);

Pause02Icon.propTypes = {
  color: PropTypes.string,
};

export default Pause02Icon;
